import Transformer from "../Transformer";
import { i18n } from "../../plugins/vue-i18n";

export default class CounterpartyAddressTypeTransformer extends Transformer {
  static fetch(item) {
    const transformed = {
      addressFullName: item.value,
      displayName: i18n.t("CONTENT.counterparty." + item.value)
    };
    return Object.freeze(transformed);
  }
}
